<!--Table-->
<div class="table-main-body">
	<div class="InfoHeading">
		<h4>Students:</h4>
	</div>

	<p-table
		*ngIf="lstStudent.length > 0"
		#mydt
		[value]="lstStudent"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedStudent"
		dataKey="StudentID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Advisor-->
				<th>
					<p-columnFilter type="text" field="Advisor" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Status-->
				<th>
					<p-columnFilter field="StatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStatusDesc
								[ngModel]="value"
								[options]="lstStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="Advisor">Counselor<p-sortIcon field="Advisor"></p-sortIcon></th>
				<th pSortableColumn="StatusDesc">Active<p-sortIcon field="StatusDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Student>
			<tr [pSelectableRow]="Student">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Student[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>

	<div class="InfoHeading" *ngIf="SectionID == -1">
		<h4>Select a Section</h4>
	</div>

	<div class="InfoHeading" *ngIf="lstStudent.length == 0 && SectionID != -1">
		<h4>No Records Found</h4>
	</div>
</div>
